import ajaxRequest from './ajax'
import qs from "qs"

// 获取公告列表
export const get_notice_list_by_user = params => {
  return ajaxRequest.get("notice/get_notice_list_by_user?" + qs.stringify(params))
}
// 获取公告详情/api/notice/get_notice_detail_by_user
export const get_notice_detail_by_user = params => {
  return ajaxRequest.get("notice/get_notice_detail_by_user?" + qs.stringify(params))
}
export const set_notice_readed_by_user = () => {
  return ajaxRequest.post('notice/set_notice_readed_by_user')
}

//获取附件的基本信息
export const get_notice_media_basic_info = params => {
  return ajaxRequest.get("notice/get_notice_media_basic_info?" + qs.stringify(params))
}

//获取附件的下载地址
export const get_notice_media_download_url = params => {
  return ajaxRequest.get("notice/get_notice_media_download_url?" + qs.stringify(params));
}

//发送邮件
export const send_email_to_emoment_support = params => {
  return ajaxRequest.post('notice/send_email_to_emoment_support', params)
}

export const get_notice_detail_notice_id= query => {
  return ajaxRequest.get('notice/get_notice_detail_notice_id?'+qs.stringify(query) )
}



// WEBPACK FOOTER //
// ./src/api/notice.js